import React from 'react';
import Image from '../../../components/AppImage';

const PopularPagesHeatmap = ({ pages }) => {
  const maxViews = Math.max(...pages?.map(p => p?.views));
  
  const getHeatColor = (views) => {
    const intensity = (views / maxViews) * 100;
    if (intensity >= 80) return 'bg-destructive/20 border-destructive/40';
    if (intensity >= 60) return 'bg-warning/20 border-warning/40';
    if (intensity >= 40) return 'bg-accent/20 border-accent/40';
    if (intensity >= 20) return 'bg-success/20 border-success/40';
    return 'bg-muted border-border';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-elevation-sm">
      <div className="mb-4 md:mb-6">
        <h3 className="text-base md:text-lg font-semibold text-foreground">Popular Pages Heatmap</h3>
        <p className="text-xs md:text-sm text-muted-foreground mt-1">Page engagement intensity visualization</p>
      </div>
      <div className="flex items-center gap-2 mb-4 text-xs text-muted-foreground">
        <span>Low</span>
        <div className="flex gap-1">
          <div className="w-4 h-4 rounded bg-muted border border-border"></div>
          <div className="w-4 h-4 rounded bg-success/20 border border-success/40"></div>
          <div className="w-4 h-4 rounded bg-accent/20 border border-accent/40"></div>
          <div className="w-4 h-4 rounded bg-warning/20 border border-warning/40"></div>
          <div className="w-4 h-4 rounded bg-destructive/20 border border-destructive/40"></div>
        </div>
        <span>High</span>
      </div>
      <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-10 gap-2 md:gap-3">
        {pages?.map((page) => (
          <div
            key={page?.pageNumber}
            className={`aspect-[3/4] rounded-lg border-2 ${getHeatColor(page?.views)} transition-all duration-250 hover:scale-105 cursor-pointer overflow-hidden group relative`}
            title={`Page ${page?.pageNumber}: ${page?.views?.toLocaleString()} views`}
          >
            <Image
              src={page?.thumbnail}
              alt={`Catalog page ${page?.pageNumber} thumbnail showing ${page?.views?.toLocaleString()} views with engagement heatmap visualization`}
              className="w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity"
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-xs md:text-sm font-semibold text-foreground bg-background/80 px-2 py-1 rounded">
                {page?.pageNumber}
              </span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 bg-background/90 p-1 opacity-0 group-hover:opacity-100 transition-opacity">
              <p className="text-xs text-center text-foreground font-medium truncate">{page?.views?.toLocaleString()}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PopularPagesHeatmap;